import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'navGroupItem',
  title: 'Nav Group Item',
  type: 'object',
  fields: [
    defineField({
      title: 'Link',
      name: 'link',
      type: 'link',
    }),
    defineField({
      title: 'Nav Items',
      name: 'items',
      type: 'array',
      of: [{ type: 'link' }],
    }),
  ],
  preview: {
    select: {
      link: 'link',
    },
    prepare(selection) {
      const { title = 'New nav item...' } = selection?.link || {}
      return {
        title,
        subtitle: '',
      }
    },
  },
})